<template>
	<div>
		<el-row>
			<el-form class="search_form" :model="searchForm" ref="searchForm" size="mini" :inline="true">
				<el-col :span="3">
					<el-form-item prop="stationId">
						<el-cascader v-model="cascaderValue" :options="cascaderOptions"
							:props="{ expandTrigger: 'hover' }" @change="cascaderChange" placeholder="输入关键字搜索"
							filterable></el-cascader>
					</el-form-item>
				</el-col>
				<el-col :span="3">
					<el-form-item prop="pileCode">
						<el-input placeholder="桩编号" v-model="searchForm.pileCode" clearable></el-input>
					</el-form-item>
				</el-col>
				<!--        <el-col :span="3">-->
				<!--          <el-form-item prop="commandPort">-->
				<!--            <el-input placeholder="端口号" v-model="searchForm.commandPort" clearable></el-input>-->
				<!--          </el-form-item>-->
				<!--        </el-col>-->
				<el-col :span="4">
					<el-form-item>
						<el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
						<el-button type="primary" icon="el-icon-search" @click="submitSearchForm"
							:loading="searchLoading">查询
						</el-button>
					</el-form-item>
				</el-col>
			</el-form>
		</el-row>
		<el-table :data="pileDataTables" stripe style="dwidth: 100%" ref="pileDataTable" border v-loading="listLoading">
			<!--                <af-table-column type="selection" width="30"></af-table-column>-->
			<af-table-column prop="stationName" label="所属站"></af-table-column>
			<af-table-column prop="name" label="桩名称"></af-table-column>
			<af-table-column prop="pileCode" label="桩编号"></af-table-column>
			<af-table-column prop="currentType.message" label="类型"></af-table-column>
			<af-table-column prop="faultOrService.message" label="状态"></af-table-column>
			<af-table-column prop="ratedPower" label="功率(kW)"></af-table-column>
			<af-table-column prop="controlledPower" label="功率控制(kW)"></af-table-column>
			<af-table-column label="操作" width="350">
				<template slot-scope="scope">
					<el-popover style="margin-right: 10px;" placement="top" width="160">
						<el-form class="faultListing" :model="faultListingForm" ref="faultListingForm" size="mini">
							<p style="text-align: center; background-color: white;color:red">确定要操作<br><span
									style="color: #2c3e50">{{scope.row.pileCode}}</span>吗？</p>
							<el-col>
								<el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
									<el-input v-model="faultListingForm.id" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-form>
						<div style="text-align: center">
							<el-button type="primary" size="mini" @click="faultListingFormSubmit(scope.row)"
								:loading="faultListingSubmitLoading">确定</el-button>
						</div>
						<el-button slot="reference" size="mini"
							v-if="checkPermission(['bee:res:deviceControl:faultListing'])" class="faultListing" plain
							@click="faultListing(scope.$index, scope.row)">故障挂牌
						</el-button>
					</el-popover>
					<el-popover style="margin-right: 10px;" placement="top" width="160">
						<el-form class="inspectionAndMaintenance" :model="inspectionAndMaintenanceForm"
							ref="remotelyStopForm" size="mini">
							<p style="text-align: center; background-color: white;color:red">确定要操作<br><span
									style="color: #2c3e50">{{scope.row.pileCode}}</span>吗？</p>
							<el-col>
								<el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
									<el-input v-model="inspectionAndMaintenanceForm.id" autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-form>
						<div style="text-align: center">
							<el-button type="primary" size="mini" @click="inspectionAndMaintenanceSubmit(scope.row)"
								:loading="inspectionAndMaintenanceSubmitLoading">确定</el-button>
						</div>
						<el-button slot="reference" size="mini" class="inspectionAndMaintenance"
							v-if="checkPermission(['bee:res:deviceControl:inspectionAndMaintenance'])" plain
							@click="inspectionAndMaintenance(scope.$index, scope.row)">检测维修
						</el-button>
					</el-popover>
					<el-popover style="margin-right: 10px;" placement="top" width="160">
						<el-form class="powerControl" :model="powerControlForm" :rules="checkPower"
							ref="powerControlForm" size="mini">
							<el-col>
								<el-form-item prop="controlledPower">
									<el-input placeholder="功率" v-model="powerControlForm.controlledPower" clearable>
									</el-input>
								</el-form-item>
							</el-col>
						</el-form>
						<div style="text-align: center">
							<!--                <el-button size="mini" @click="visible = false">关闭</el-button>-->
							<el-button type="primary" size="mini" @click="powerControlSubmit(scope.row)"
								:loading="powerControlSubmitLoading">控制</el-button>
						</div>
						<el-button slot="reference" size="mini"
							v-if="checkPermission(['bee:res:deviceControl:powerControl'])" class="powerControl" plain
							@click="powerControl(scope.$index, scope.row)">功率控制
						</el-button>
					</el-popover>

				</template>
			</af-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
	</div>
</template>

<script>
	import Pagination from '@/module/operatingCenter/component/Pagination'
	import deviceControlApi from '../../api/deviceControlApi'
	import pileApi from '../../../resourceCenter/api/pileApi';
	import {
		isInteger
	} from '../../../../common/validator'
	export default {
		name: "pile",
		data() {
			return {
				formLabelWidth: '150px',
				searchForm: {},
				pileDataTables: [],
				searchLoading: false,
				listLoading: false,
				cascaderValue: [],
				cascaderOptions: [],
				// 编辑与添加
				editForm: {},
				// rules表单验证
				rules: {
					userSex: [{
						required: true,
						message: '',
						trigger: 'blur'
					}]
				},
				checkPower: {
					controlledPower: [{
						required: true,
						message: '请输入功率',
						trigger: 'blur'
					}, {
						validator: isInteger,
						trigger: 'blur'
					}]
				},
				// 分页参数
				pageparam: {
					t: {},
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				faultListingForm: {},
				faultListingFormVisible: false,
				faultListingSubmitLoading: false,
				inspectionAndMaintenanceForm: {},
				inspectionAndMaintenanceFormVisible: false,
				inspectionAndMaintenanceSubmitLoading: false,
				powerControlForm: {},
				powerControlFormVisible: false,
				powerControlSubmitLoading: false
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		created() {},
		methods: {
			resetSearchForm() {
				this.cascaderValue = []
				this.searchForm = {}
				this.submitSearchForm()
			},
			submitSearchForm() {
				this.searchLoading = true;
				this.listLoading = true;
				// let param = Object.assign({}, this.stationSearchForm)
				// para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
				this.pageparam.t = this.searchForm;
				let param = Object.assign({}, this.pageparam);
				deviceControlApi.getPilePageList(param).then((res) => {
					if (res.code === 0) {
						this.pageparam.total = res.data.total;
						this.pileDataTables = res.data.records;
						//this.$emit('setPileDataTable',res.data.records);
						// this.$message({
						//   message: res.message,
						//   type: 'success'
						// });
					} else {
						this.$message.error(res.message);
					}
					this.searchLoading = false;
					this.listLoading = false;
				});
			},
			getCascaderOptions() {
				let operatorId = this.$store.getters.operatorIds.length == 0 ? '' : this.$store.getters.operatorIds[0]
				const userType = this.$store.getters.userType
				if (userType.toLowerCase().indexOf('admin') != 1) {
					operatorId = null
				}
				deviceControlApi.getCascaderOptions(operatorId).then((res) => {
					if (res.code === 0) {
						let data = []
						let province = res.data.provinceMap
						let city = res.data.cityMap
						let station = res.data.nameMap
						for (let i = 0; i < province.length; i++) {
							console.log(province)
							data[i] = {
								label: province[i].province,
								children: []
							}
							for (let j = 0; j < city.length; j++) {
								if (data[i].label === city[j].province) {
									data[i].children[data[i].children.length] = {
										label: city[j].city,
										// value:'city:'+city[j].city,
										children: []
									}
									for (let n = 0; n < station.length; n++) {
										if (data[i].children[data[i].children.length - 1].label === station[n]
											.city) {
											data[i].children[data[i].children.length - 1].children.push({
												label: station[n].stationName,
												value: station[n].id,
											})
										}
									}
								}
							}
						}
						this.cascaderOptions = data
					}
				});
			},
			cascaderChange(value) {
				this.searchForm.stationId = value[2]
			},
			changePage() {
				this.submitSearchForm();
			},
			faultListing() {

			},
			faultListingFormSubmit(row) {
				this.faultListingForm = row.id;
				let param = JSON.stringify(this.faultListingForm);
				deviceControlApi.faultListing(param).then((res) => {
					if (res.code === 0) {
						this.$message({
							message: res.message,
							type: 'success'
						})
					} else {
						this.$message.info(res.message)
					}
				})
			},

			inspectionAndMaintenance() {

			},
			inspectionAndMaintenanceSubmit(row) {
				this.faultListingForm = row.id;
				let param = JSON.stringify(this.faultListingForm);
				deviceControlApi.inspectionAndMaintenance(param).then((res) => {
					if (res.code === 0) {
						this.$message({
							message: res.message,
							type: 'success'
						})
					} else {
						this.$message.info(res.message)
					}
				})
			},
			powerControl() {

			},
			powerControlSubmit(row) {
				this.$refs.powerControlForm.validate(valid => {
					if (!valid) {
						return false;
					} else {
						this.powerControlSubmitLoading = true
						this.powerControlForm.id = row.id
						let param = JSON.stringify(this.powerControlForm)
						deviceControlApi.powerControl(param).then((res) => {
							if (res.code === 0) {
								this.$message({
									message: res.message,
									type: 'success'
								})
								row.controlledPower = this.powerControlForm.controlledPower
							} else {
								this.$message.error(res.message)
							}
						})
						this.powerControlSubmitLoading = false
					}
				})
			}
		},
		mounted: function() {
			this.submitSearchForm()
			this.getCascaderOptions()
		},
		filters: {
			statusFilter(runStatus) {
				const statusMap = {
					0: 'success',
					1: 'info',
					2: 'danger',
					3: 'warning'
				}
				return statusMap[runStatus]
			}
		},
		props: {
			pileDataTable: ""
		}
	}
</script>

<style lang="less" scoped>
	.el_search {
		background-color: teal;
		color: white;
	}

	.el_clear {
		background-color: darkorange;
		color: white;
	}

	.sendQRCode {
		background-color: #b2e042;
		color: white;
	}

	.remotelyControl {
		background-color: #1cbcff;
		color: white;
	}

	.sendRate {
		background-color: #12d900;
		color: white;
	}

	.faultListing {
		background-color: #b91797;
		color: white;
	}

	.inspectionAndMaintenance {
		background-color: #00eabb;
		color: white;
	}

	.powerControl {
		background-color: #00a9b9;
		color: white;
	}

	.limitedTimeCharging {
		background-color: #d949c8;
		color: white;
	}
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/deviceControl/pile.vue